export enum TransactionActionTypes {
    SET_TRANSACTION = 'SET_TRANSACTION',
    SET_BUYER_INFO = 'SET_BUYER_INFO',
    SET_BUYER_INFO_BY_SOCIAL_REF_ID = 'SET_BUYER_INFO_BY_SOCIAL_REF_ID',

}
